var AttributeFilter = React.createClass({
  propTypes: {
    attributeSets: React.PropTypes.array.isRequired,
    attributes: React.PropTypes.array,
    selectedSetName: React.PropTypes.string,
    selectedAttributeKeys: React.PropTypes.array,
    onAttributeSetChanged: React.PropTypes.func,
    onAttributesChanged: React.PropTypes.func,
	showAttributeFilter: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      attributeSets: [],
      attributes: [],
      selectedSetName: "",
	  showAttributeFilter: false
    }
  },
  isFilterApplied() {
    return this.props.selectedSetName.length != 0;
  },
  render() {
    let { showAttributeFilter } = this.props;
    if (!showAttributeFilter || this.props.attributeSets.length == 0) {
      return <span />
    }

    let component = this.isFilterApplied() ?
      <AttributesList attributeSetName={this.props.selectedSetName}
        selectedAttributeKeys={this.props.selectedAttributeKeys}
        attributes={this.props.attributes}
        showClear={this.isFilterApplied()}
        onAttributesChanged={this.props.onAttributesChanged} /> :
      <AttributeSetsList attributeSets={this.props.attributeSets}
        onAttributeSetChanged={this.props.onAttributeSetChanged} />;

    return (
      <BrowseFilter title={Labels.getLabel("Attributes")} filterType="filter-type__attribute" isOpen={this.props.isOpen} ariaLabel="Solution Attribute Filter">
        {component}
      </BrowseFilter>
    )
  }
});